import { Box, Typography, Grid2 as Grid, Card, CardContent, CardMedia } from "@mui/material";
import Inspira1 from '../../../assets/images/inspiration1.png';
import Inspira2 from '../../../assets/images/inspiration2.png';
import Inspira3 from '../../../assets/images/inspiration3.png';
import './inspiration.css';

const inspirationData = [
  {
    title: "Un super emplatado para tu noche de chicas",
    text: "Las reuniones de amigas son increíbles cuando tienes todo lo que necesitan ambas para pasarla bien. Te dejamos una lista con cinco cosas para que tengan una noche perfecta.",
    image: Inspira1,
  },
  {
    title: "Antojitos deliciosos para tus reuniones",
    text: "Implementar antojitos en tus reuniones es un gran motivo para abrir el apetito y romper el hielo con los invitados. Te dejamos unas ideas geniales con Marián® para inspirarte durante tu próxima reunión.",
    image: Inspira2,
  },
  {
    title: "¡Recuerdos para fiestas con galletas!",
    text: "Si en tu próxima reunión estás buscando un detalle increíble para tus invitados: ¡Dilo con galletas! Te dejamos unos tips geniales para crear estos dulces recuerdos.",
    image: Inspira3,
  },
];

export default function Inspiration() {
  return (
    <Box sx={{ py: 6, px: 2, backgroundColor: "#fff", textAlign: "center" }} className="inspiration-container">
      <Typography
        className="inspiration-title"
        variant="h4"
        sx={{ color: "#E4535F", fontWeight: "bold", mb: 4, fontFamily: "BloodOrange, sans-serif" }}
      >
        ✧ Inspiración para crear ✧
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        {inspirationData.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              className="inspiration-card"
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: index % 2 === 0 ? "column" : "column-reverse",
                justifyContent: "space-between",
                border: "none",
                boxShadow: "none",
                backgroundColor: "white"
              }}
            >
              <CardMedia
                component="img"
                height="300"
                image={item.image}
                alt={item.title}
                sx={{ objectFit: "contain"}}
              />
              <CardContent sx={{ flexGrow: 1, maxWidth: 280, mx: "auto", textAlign: "left" }} className="inspiration-card-content">
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bold", color: "#E4535F", mb: 1, fontFamily: "BloodOrange, sans-serif" }}
                >
                  {item.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 6, // número de líneas visibles
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  color: "#3D1C02",
                  fontWeight: "500",
                  fontFamily: "Montserrat, sans-serif",
                }}>
                  {item.text}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
